"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface FieldDef {
  key: string;
  label: string;
  type?: "text" | "money" | "date" | "json";
}

interface DetailDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  row: Record<string, unknown> | null;
  fields: FieldDef[];
  rowJson?: string | null;
}

function formatValue(val: unknown, type: string): string {
  if (val === null || val === undefined) return "-";
  if (type === "money") return `¥${Number(val).toLocaleString("zh-CN", { minimumFractionDigits: 2 })}`;
  if (type === "date") return String(val).slice(0, 10);
  return String(val);
}

export function DetailDialog({ open, onOpenChange, title, row, fields, rowJson }: DetailDialogProps) {
  if (!row) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
          {fields.map((f) => (
            <div key={f.key} className="flex justify-between border-b border-zinc-100 py-1">
              <span className="text-zinc-500 shrink-0">{f.label}</span>
              <span className="text-zinc-900 text-right ml-4">
                {formatValue(row[f.key], f.type ?? "text")}
              </span>
            </div>
          ))}
        </div>

        {rowJson && (
          <div className="mt-4">
            <p className="text-sm text-zinc-500 mb-1">原始 JSON 数据</p>
            <pre className="bg-zinc-900 text-zinc-100 rounded-lg p-4 text-xs overflow-x-auto whitespace-pre-wrap">
              {(() => {
                try {
                  return JSON.stringify(JSON.parse(rowJson), null, 2);
                } catch {
                  return rowJson;
                }
              })()}
            </pre>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}